import React, { FC, useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { Tooltip } from '@mui/material';

import { ITicket } from '../../../../../services/tickets/types';
import { TICKET } from '../../../../../router/routes';
import TicketChatIcon from './TicketChatIcon';
import { useAppSelector } from '../../../../../store/hooks';
import { PortalConfigSelector } from '../../../../../store/config/selectors';
import { PsaTypes } from '../../../../../services/config/types';

import useStyles from '../../../styles';

interface IProps {
  ticket: ITicket;
  disableChats: boolean;
  closeStatusId: string;
}

const TicketListItem: FC<IProps> = ({ ticket, disableChats, closeStatusId }) => {
  const navigate = useNavigate();
  const classes = useStyles();
  const { psaType } = useAppSelector(PortalConfigSelector);

  const isTicketClosed = useMemo(() => {
    return +ticket.statusId === +closeStatusId;
  }, [ticket.statusId, closeStatusId]);

  const handleItemClick = useCallback(() => {
    navigate(
      TICKET.replace(
        ':ticketId',
        psaType === PsaTypes.Autotask ? ticket?.ticketNumber ?? '' : ticket.id,
      ),
    );
  }, [navigate, ticket.id, psaType, ticket.ticketNumber]);

  const ticketDisplayId = useMemo(() => ticket.ticketNumber ?? ticket.id, [ticket]);
  const ticketDescription = useMemo(
    () => (psaType === PsaTypes.Halo ? ticket.details : ticket.description),
    [ticket, psaType],
  );

  return (
    <div className={classes.ticketListItem} onClick={handleItemClick} role="presentation">
      <div className={classes.ticketListItemTitle}>
        <Tooltip title={ticketDescription ? `Description: ${ticketDescription}` : undefined}>
          <div>{ticket.title}</div>
        </Tooltip>
        <div className="id">#{ticketDisplayId}</div>
      </div>

      <div className={classes.ticketListItemStatus}>
        <div>{ticket.status}</div>
        {!disableChats && (
          <TicketChatIcon
            chatId={ticket.chatId}
            ticketId={ticket.id}
            ticketNumber={ticket.ticketNumber}
            isTicketClosed={isTicketClosed}
          />
        )}
      </div>
    </div>
  );
};

export default TicketListItem;
